import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import history from './history';
import './App.css';
import Login from './auth_components/js/Login';
import HomePage from './Containers/HomePage';

import InitialisationContainer from './Containers/InitialisationContainer';

import MasterContainer from './Containers/MasterContainer';

import SettingsContainer from './Containers/SettingsContainer';

import LogContainer from './Containers/LogContainer';
import AddNewContainerMain from './Containers/AddNewContainerMain';
import ViewAllContainer from './Containers/ViewAllContainer';
import AddAwardContainer from './Components/AddNew/AddAwardContainer';
import AddAwarContainerMain from './Containers/AddAwarContainerMain';
import AddPatentNewContainerMain from './Containers/AddPatentNewContainerMain';
import AddCollaborationNewContainerMain from './Containers/AddCollaborationNewContainerMain';

import AddStaffContainerMain from './Containers/AddStaffContainerMain';
import LaboratoryContainer from './Containers/LaboratoryContainer';
import EmployeeContainer from './Containers/EmployeeContainer';
import FeedbackContainer from './Containers/FeedbackContainer';



class App extends Component {
  render() {
    return (
      <Router history={history} >
      
        <div>
          <Switch>
            <Route path="/login" component={Login} />
            <Route exact path="/" component={HomePage} />

            <Route exact path="/initialisation" component={InitialisationContainer} />     
            <Route exact path="/settings" component={SettingsContainer} />     


            <Route exact path="/employee" component={EmployeeContainer} />     
            <Route exact path="/notices" component={AddNewContainerMain} />     
            <Route exact path="/award" component={AddAwarContainerMain} /> 
            <Route exact path="/patent" component={AddPatentNewContainerMain} /> 
            <Route exact path="/feedback" component={FeedbackContainer} /> 
            
            <Route exact path="/collaborations" component={AddCollaborationNewContainerMain} /> 
            <Route exact path="/staff" component={AddStaffContainerMain} />     

            <Route exact path="/news" component={AddNewContainerMain} />     
            <Route exact path="/events" component={AddNewContainerMain} />     
            <Route exact path="/edit" component={AddNewContainerMain} />     
            <Route exact path="/view" component={ViewAllContainer} />     
            <Route exact path="/laboratory" component={LaboratoryContainer} />     
            <Route exact path="/laboratory/view" component={LaboratoryContainer} />     

            <Route exact path="/master/file" component={MasterContainer} />       
            <Route exact path="/master/placement" component={MasterContainer} />       
            <Route exact path="/master/gallery" component={MasterContainer} />       
            {/* <Route exact path="/master/course" component={MasterContainer} />       
            <Route exact path="/master/department" component={MasterContainer} />       
            <Route exact path="/master/subject" component={MasterContainer} />       
            <Route exact path="/master/stream" component={MasterContainer} />       
            <Route exact path="/master/session" component={MasterContainer} />     
            <Route exact path="/master/leave" component={MasterContainer} />     
            <Route exact path="/master/class" component={MasterContainer} />     
            <Route exact path="/master/routine" component={MasterContainer} />     
            <Route exact path="/master/section" component={MasterContainer} />     
            <Route exact path="/master/access" component={MasterContainer} />     
            <Route exact path="/master/doctype" component={MasterContainer} />  */}     
            <Route exact path="/master/passwordchange" component={MasterContainer} />    
            
            
      





            <Route exact path="/logs" component={LogContainer} /> 



          </Switch>
        </div>
       
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js